let calLoaded = false;
let calLoadPromise = null;

function loadCalScript() {
  if (calLoaded) return Promise.resolve();
  if (calLoadPromise) return calLoadPromise;

  calLoadPromise = new Promise((resolve, reject) => {
    // Cal.com requires bootstrapping a queue function before the script loads
    (function (C, A, L) {
      let p = function (a, ar) {
        a.q.push(ar);
      };
      let d = C.document;
      C.Cal =
        C.Cal ||
        function () {
          let cal = C.Cal;
          let ar = arguments;
          if (!cal.loaded) {
            cal.ns = {};
            cal.q = cal.q || [];
            let script = d.head.appendChild(d.createElement("script"));
            script.src = A;
            script.async = true;
            script.onload = () => {
              calLoaded = true;
              resolve();
            };
            script.onerror = () =>
              reject(new Error("Failed to load Cal.com embed"));
            cal.loaded = true;
          }
          if (ar[0] === L) {
            const api = function () {
              p(api, arguments);
            };
            const namespace = ar[1];
            api.q = api.q || [];
            typeof namespace === "string"
              ? (cal.ns[namespace] = api) && p(api, ar)
              : p(cal, ar);
            return;
          }
          p(cal, ar);
        };
    })(window, "https://app.cal.com/embed/embed.js", "init");

    window.Cal("init", { origin: "https://gokick.cal.com" });
  });

  return calLoadPromise;
}

export async function initCalEmbed() {
  await loadCalScript();
}

export async function openCalPopup(
  calLink = "sleep-concierge/introduction",
  metadata = {},
) {
  await loadCalScript();

  window.Cal("ui", {
    hideEventTypeDetails: false,
  });

  const phone = metadata.userPhone ? `+1${metadata.userPhone}` : "";

  window.Cal("modal", {
    calLink: calLink,
    config: {
      layout: "month_view",
      metadata: metadata,
      name: metadata.userName || "",
      email: metadata.userEmail || "",
      attendeePhoneNumber: phone,
      location: phone
        ? JSON.stringify({ value: "phone", optionValue: phone })
        : "",
    },
  });
}

export async function initCalInline(
  elementId,
  calLink = "sleep-concierge/introduction",
) {
  await loadCalScript();

  window.Cal("inline", {
    elementOrSelector: `#${elementId}`,
    calLink: calLink,
    config: {
      layout: "month_view",
    },
  });

  window.Cal("ui", {
  });
}
